import { render } from "./PortfolioGride.vue?vue&type=template&id=0d5fd1b6&scoped=true"
import script from "./PortfolioGride.vue?vue&type=script&lang=js"
export * from "./PortfolioGride.vue?vue&type=script&lang=js"

import "./PortfolioGride.vue?vue&type=style&index=0&id=0d5fd1b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5fd1b6"]])

export default __exports__